import DsTree from './DsTree'

export default Vue => {
  Vue.component(DsTree.name, DsTree)
}



// WEBPACK FOOTER //
// ./src/components/dstree/index.js